import {
    FETCH_ALLOCATED_PAYMENT_INVOICELIST_FAILURE,
    FETCH_ALLOCATED_PAYMENT_INVOICELIST_SUCCESS,
    FETCH_ALLOCATED_PAYMENT_INVOICELIST_REQUEST,
  } from "./FetchAllocatedPaymentsTypes";
  import api from "../../utils/Api";
  import axios from 'axios';
  
  export const fetchAllocatePaymentInvoiceListRequest = () => {
    return {
      type: FETCH_ALLOCATED_PAYMENT_INVOICELIST_REQUEST,
    };
  };
  
  export const fetchAllocatePaymentInvoiceListSuccess = (allocatedInvoiceList) => {
    return {
      type: FETCH_ALLOCATED_PAYMENT_INVOICELIST_SUCCESS,
      payload: allocatedInvoiceList,
    };
  };
  
  export const fetchAllocatedInvoiceListFailure = (error) => {
    return {
      type: FETCH_ALLOCATED_PAYMENT_INVOICELIST_FAILURE,
      payload: error,
    };
  };
  
  const CancelToken = axios.CancelToken;
  let cancelRequest;
  export const fetchAllocatedInvoiceList = (searchKey, sortBy, page, payload) => {
    //cancel previous request if multiple hits done.
    cancelRequest && cancelRequest();
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "payment/allocatedPayment/fetch?search_key=" +
    searchKey +
    "&sort_by=" +
    sortBy +
    "&page=" +
    page;
  
    if(payload && payload.dateFrom && payload.dateFrom !== "Not Available"){
      url += "&service_start_date=gte:"+ payload.dateFrom;
    }
    if(payload && payload.dateTo && payload.dateTo !== "Not Available"){
        url += "&service_start_date=lte:"+ payload.dateTo;
    }
    if(payload && payload.status){
        url += "&status="+ payload.status;
    }
  
    return async (dispatch) => {
      dispatch(fetchAllocatePaymentInvoiceListRequest());
      try {
        const response = await api.get(
         url,
          {
            headers: headers,
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
          })
          }
        );
        const allocatedInvoiceList = response.data.data;
        //console.log("*************** invoiceList", invoiceList);
        dispatch(fetchAllocatePaymentInvoiceListSuccess(allocatedInvoiceList));
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Error: ', error.message); // => prints: Api is being canceled
        } 
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchAllocatedInvoiceListFailure(errorMsg));
      }
    };
  };
  